export const DEFAULT_BASE_DERIVATION_PATH = "m/44'/60'";
export const DEFAULT_NUM_ADDRESSES_TO_FETCH = 5;
export const DEFAULT_ADDRESS_SEARCH_LIMIT = 100;
//# sourceMappingURL=constants.js.map